var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"student-avatar",attrs:{"src":_vm.avatarURL,"alt":"avatar","width":_vm.size,"height":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }